import React, { useEffect, useRef, useState } from "react";
import "./view.css";
import { Link, useParams } from "react-router-dom";
import { blformService } from "../../../services";
import { jsPDF } from "jspdf";
import { Button, Col, Row, Spin } from "antd";
import { changeDocumentTitle } from "../../../utils/title";
import html2canvas from "html2canvas";

export const DockReceipt = () => {
  const { id } = useParams();
  const pdfRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [blform, setBlform] = useState({});

  const downloadPDF = async () => {
    setPdfLoading(true);

    const pdf = new jsPDF("p", "pt", "a4");
    const receipts = document.querySelectorAll(".pdf-receipt");

    for (let i = 0; i < receipts.length; i++) {
      const canvas = await html2canvas(receipts[i], {
        // scale: 2,
        scale: 1,
        useCORS: true,
      });

      // const imgData = canvas.toDataURL("image/png");
      // const imgData = canvas.toDataURL("image/jpeg", 0.7); // 70% quality
      const imgData = canvas.toDataURL("image/jpeg");
      const imgWidth = pdf.internal.pageSize.getWidth();
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      if (i > 0) pdf.addPage();
      pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
    }

    pdf.save(`${blform?.form?.booking_no} - Dock Receipt.pdf`);
    setPdfLoading(false);
  };

  const initialize = async () => {
    setLoading(true);
    const { success, data } = await blformService.view(id);
    if (success) setBlform(data);
    setLoading(false);
  };

  useEffect(() => {
    changeDocumentTitle("View Dock Receipt");
    initialize();
  }, [id]);

  return (
    <>
      <Row gutter={24} className="flex justify-end">
        <Link to={`/operations/bl-forms/edit/${id}`}>
          <Button type="primary">Edit</Button>
        </Link>
        <Col>
          <Button type="primary" loading={pdfLoading} onClick={downloadPDF}>
            Download Dock Receipt
          </Button>
        </Col>
        <Col>
          <Button type="primary" onClick={() => window.open(`/operations/bl-forms/pdf/${id}`)}>
            Download BL Form
          </Button>
        </Col>
      </Row>

      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "60vh", // or 100vh if you want full page
          }}
        >
          <Spin size="large" />
        </div>
      ) : (
        //  PDF ROOT
        <div
          ref={pdfRef}
          id="pdf-root"
          className="contaimermain2"
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            paddingTop: 20,
          }}>
          {blform.particulars?.map((particular, index) => (
            <div key={index} className="pdf-receipt"
              style={{
                backgroundColor: "#FFFFFF",
                borderRadius: 8,
                border: "1px solid black",
                width: "99%",
                marginBottom: 20,
                marginLeft: 5,
                marginTop: 5,
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "15px",
                  padding: 8,
                }}
              >
              </div>

              <div>
                <h1 style={{ textAlign: "center", fontWeight: "bold", fontSize: 20 }}>
                  DOCK RECEIPT
                </h1>
              </div>

              <div
                style={{
                  width: "100%",
                  borderTop: "1px solid black",
                  display: "flex",
                }}
              >
                <div className="left" style={{ width: "50%", }}>
                  <div
                    style={{ borderRight: "1px solid black", minHeight: "130px" }}
                    className="cont3"
                  >
                    <h6 style={{ minHeight: "18px" }}>
                      2. Exporter (Principal or seller-licensee and address
                      including ZIP Code)
                    </h6>
                    <p>
                      {particular.shipper} <br />
                      {particular.shipper_address} <br />
                      {particular.shipper_email && <span>EMAIL: {particular.shipper_email}</span>} <br />
                      {particular.shipper_phone && <span>PH: {particular.shipper_phone}</span>}
                    </p>
                  </div>
                  <div style={{ borderTop: "1px solid black", borderRight: "1px solid black", minHeight: "220px" }}>
                    <h6>3. Consigned To:</h6>
                    <p style={{ fontSize: 18 }}>

                      {blform?.form?.consignee?.split('\n').map((line, index) => (
                        <React.Fragment key={index}>
                          {line}
                          <br />
                        </React.Fragment>
                      ))}
                      {blform?.form?.shipper_email && <span>EMAIL: {blform?.form?.consignee_email}</span>}
                    </p>
                  </div>
                  <div style={{ borderTop: "1px solid black", minHeight: "100px" }}>
                    <h6>
                      4. Notify Party / Intermediate Consignee (Name and Address):
                    </h6>
                    <br />
                    <p>
                      Tel:{blform?.form?.party}
                    </p>
                  </div>
                  <div className="leftInner" style={{ display: "flex" }}>
                    <div
                      style={{
                        minHeight: "100px",
                        borderTop: "1px solid black",
                        borderRight: "1px solid black",
                        width: "50%",
                      }}
                    >
                      <h6>12. Pre-Carriage By</h6>
                      <p>{blform?.form?.carriage}</p>
                    </div>
                    <div
                      style={{
                        minHeight: "100px",
                        borderTop: "1px solid black",
                        width: "50%",
                      }}
                    >
                      <h6>13. Place of Receipt by Pre-Carrier</h6>
                      <p>{blform?.form?.place_of_reciept}</p>
                    </div>
                  </div>
                  <div className="leftInner" style={{ display: "flex" }}>
                    <div
                      style={{
                        minHeight: "100px",
                        borderTop: "1px solid black",
                        borderRight: "1px solid black",
                        width: "50%",
                      }}
                    >
                      <h6>14. Exporting Carrier</h6>
                      <p>{blform?.form?.exporting_carrier}</p>
                    </div>
                    <div
                      style={{
                        minHeight: "100px",
                        borderTop: "1px solid black",
                        width: "50%",
                      }}
                    >
                      <h6>15. Port of Loading/Export</h6>
                      <p>{blform?.form?.port}</p>
                    </div>
                  </div>
                  <div className="leftInner" style={{ display: "flex" }}>
                    <div
                      style={{
                        minHeight: "100px",
                        borderTop: "1px solid black",
                        borderRight: "1px solid black",
                        width: "50%",
                      }}
                    >
                      <h6>16. Foreign Port of Unloading (vessel and air only)</h6>
                      <p>{blform?.form?.discharge}</p>
                    </div>
                    <div
                      style={{
                        minHeight: "100px",
                        borderTop: "1px solid black",
                        width: "50%",
                      }}
                    >
                      <h6>17. Place of Delivery by On-Carrier</h6>
                      <p>{blform?.form?.place_of_delivery}</p>
                    </div>
                  </div>
                </div>
                <div className="right" style={{ width: "50%" }}>
                  <div className="leftInner" style={{ display: "flex" }}>
                    <div
                      style={{
                        minHeight: "80px",
                        borderRight: "1px solid black",
                        width: "50%",
                      }}
                    >
                      <h6 style={{ minHeight: '30px' }}>5. Document No. (Carrier Booking No.)</h6>
                      <p>{blform?.form?.booking_no}</p>
                    </div>
                    <div
                      style={{
                        minHeight: "80px",
                        width: "50%",
                      }}
                    >
                      <h6 style={{ minHeight: '30px' }}>5a. Bill of Loading No</h6>
                      <p>{blform?.form?.loading_no}</p>
                    </div>
                  </div>
                  <div className="leftInner" style={{ display: "flex" }}>
                    <div
                      style={{
                        minHeight: "100px",
                        borderTop: "1px solid black",
                        borderRight: "1px solid black",
                        width: "50%",
                      }}
                    >
                      <h6>6. Export References</h6>
                      <p>
                        {particular.itn_number} <br />
                        {/* {blform?.form?.export_references} */}
                      </p>
                    </div>
                    <div
                      style={{
                        minHeight: "100px",
                        borderTop: "1px solid black",
                        width: "50%",
                      }}
                    >
                      <h6>6a. Reference No.</h6>
                      <p>{blform?.form?.reference_no}</p>
                    </div>
                  </div>
                  <div
                    style={{
                      minHeight: "170px",
                      width: "100%",
                      borderTop: "1px solid black"
                    }}
                  >
                    <h6>7. Forwarding Agent (Name and Address)</h6>
                    <br />
                    <p style={{ whiteSpace: "pre-line" }}>{blform?.form?.agent}</p>
                  </div>
                  <div
                    style={{
                      minHeight: "60px",
                      borderTop: "1px solid black",
                      borderLeft: "1px solid black",
                      width: "100%",
                    }}
                  >
                    <h6>8. Point (State) or Origin or FTZ Number</h6>
                    <p>{blform?.form?.point}</p>
                  </div>
                  <div
                    style={{
                      borderTop: "1px solid black",
                      borderLeft: "1px solid black",
                      minHeight: "140px"
                    }}
                  >
                    <h6>9. Also Notify and/or Additional Routing Instructions</h6>
                    <p>{blform?.form?.party_instructions}</p>
                  </div>
                  <div className="leftInner" style={{ display: "flex" }}>
                    <div
                      style={{
                        minHeight: "100px",
                        borderTop: "1px solid black",
                        borderLeft: "1px solid black",
                        width: "50%",
                      }}
                    >
                      <h6>10. Loading Pier / Terminal</h6>
                      <p>{blform?.form?.loading_pier_terminal}</p>
                    </div>
                    <div
                      style={{
                        minHeight: "100px",
                        borderTop: "1px solid black",
                        borderLeft: "1px solid black",
                        width: "50%",
                      }}
                    >
                      <h6>10a. Closing Date</h6>
                      <p>{blform?.form?.closing_date}</p>
                    </div>
                  </div>
                  <div className="leftInner" style={{ display: "flex" }}>
                    <div
                      style={{
                        minHeight: "100px",
                        width: "50%",
                        borderTop: "1px solid black",
                        borderLeft: "1px solid black",
                      }}
                    >
                      <h6>11. Type of Move</h6>
                      <p>{blform?.form?.type_of_movement}</p>
                    </div>
                    <div
                      style={{
                        minHeight: "100px",
                        width: "50%",
                        borderTop: "1px solid black",
                        borderLeft: "1px solid black",
                      }}
                    >
                      <h6>11a. Containerized(Vessel only)</h6>
                      <p>{blform?.form?.containerized}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                style={{
                  borderTop: "1px solid black",
                  width: "100%",
                  display: "flex",
                  flexWrap: "wrap",
                }}
              >
                <div
                  style={{
                    width: "15%",
                    minHeight: "100px",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      minHeight: "45px",
                      borderBottom: "1px solid black",
                      marginBottom: 10,
                    }}
                  >
                    <h6>Marks and Numbers(18).</h6>
                  </div>
                  <p><span style={{ fontSize: 12 }}>CONTAINER NO.:</span> {blform?.form?.container_nos}</p>
                  <p><span style={{ fontSize: 12 }}>SEAL:</span> {blform?.form?.seal_nos}</p>
                </div>
                <div style={{ flex: "1", display: "flex", flexDirection: "column", }}>
                  <div style={{ display: "flex", flexWrap: "wrap" }}>
                    <div
                      style={{
                        borderLeft: "1px solid black",
                        width: "15%",
                        minHeight: "120px",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <h6 style={{ minHeight: "45px", borderBottom: "1px solid black" }}>
                        Number of Packages(19).
                      </h6>
                      <div style={{ paddingTop: 10 }}>
                        <p>{particular?.quantity}</p>
                      </div>
                    </div>

                    <div style={{ display: "flex", width: "63.5%" }}>
                      <table className="dock-receipt-tbl" style={{ width: "100%", borderCollapse: "collapse", borderLeft: "1px solid black" }}>
                        <thead >
                          <tr >
                            <td style={{
                              textAlign: "left",
                              verticalAlign: "top",
                              fontWeight: "light",
                              padding: 2,
                              borderBottom: "1px solid black"
                            }}>
                              Description of Commodities in Schedule B detail(20).
                            </td>
                            <td style={{ textAlign: "left", padding: "8px", borderBottom: "1px solid black" }}>
                            </td>
                            <td style={{
                              textAlign: "left",
                              paddingBottom: "29px",
                              paddingLeft: "4px",
                              borderBottom: "1px solid black",
                              borderLeft: "1px solid black",
                              verticalAlign: "top",
                            }}>
                              Gross Weight(21).
                            </td>
                          </tr>
                        </thead>
                        <tbody>
                          {(() => {
                            const descArr = (particular?.description || '')
                              .split(/(?=(?:^|\s)(?:19|20)\d{2})/)
                              .map(entry =>
                                entry.trim().replace(
                                  /(?<!\n)(vin\s*[:#-]?\s*[A-HJ-NPR-Z0-9]{5,17})/i,
                                  '\n$1'
                                )
                              )
                              .filter(Boolean);

                            const valueArr = particular?.value?.split('\n') || [];
                            const weightArr = particular?.weight?.split('\n') || [];

                            const maxLength = Math.max(descArr.length, valueArr.length, weightArr.length);

                            return Array.from({ length: maxLength }).map((_, index) => (
                              <tr key={index}>
                                <td style={{ padding: "3px", fontSize: "15px", whiteSpace: "pre-line" }}>
                                  {descArr[index] || ""}
                                </td>
                                <td style={{ padding: "3px", fontSize: "15px" }}>
                                  {valueArr[index] || ""}
                                </td>
                                <td style={{
                                  padding: "3px",
                                  fontSize: "15px",
                                  borderLeft: "1px solid black"
                                }}>
                                  {weightArr[index] || ""}
                                </td>
                              </tr>
                            ));
                          })()}
                        </tbody>
                      </table>
                    </div>

                    <div
                      style={{
                        borderLeft: "1px solid black",
                        width: "21.5%",
                        minHeight: "100px",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <h6 style={{ minHeight: "45px", borderBottom: "1px solid black" }}>
                        Measurement(22).
                      </h6>
                      <div style={{ padding: 10 }}>
                        <p>{particular.measurements}</p>
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      borderTop: "1px solid black",
                      borderLeft: "1px solid black",
                      width: "100%",
                      minHeight: "45px",
                    }}
                  >
                    <p>{blform?.form?.note_1}</p>
                  </div>
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "row", minHeight: 320 }}>
                <div
                  style={{
                    width: "70%",
                    borderTop: "1px solid black",
                    paddingTop: 10
                  }}
                >
                  <div className="dock-line">DELIVERED BY:</div>
                  <div className="dock-line">LIGHTER TRUCK:</div>
                  <div className="dock-line">ARRIVED- DATE:  TIME:</div>
                  <div className="dock-line">UNLOADED- DATE:  TIME:</div>
                  <div className="dock-line">CHECKED BY:</div>
                  <div className="dock-line">PLACED IN SHIP LOCATION:</div>
                  <div className="dock-line">ON DOCK</div>
                </div>
                <div
                  style={{
                    minHeight: "100%",
                    width: "30%",
                    borderTop: "1px solid black",
                    borderLeft: "1px solid black",
                    paddingTop: 10
                  }}
                >
                  <div className="dock-block dock-bold">
                    RECEIVED THE ABOVE DESCRIBED GOODS OR PACKAGES SUBJECT TO ALL THE TERMS OF THE
                    UNDERSIGNED'S REGULAR FORM OF DOCK RECEIPT AND BILL OF LADING WHICH SHALL
                    CONSTITUTE THE CONTRACT UNDER WHICH THE GOODS ARE RECEIVED, COPIES OF WHICH
                    ARE AVAILABLE FROM THE CARRIER ON REQUEST AND MAY BE INSPECTED AT ANY OF ITS
                    OFFICES.
                  </div>

                  <div className="dock-block">FOR THE MASTER</div>
                  <div className="dock-block">BY __________</div>

                  <div className="dock-block">RECEIVING CLERK</div>
                  <div className="dock-block">DATE __________</div>
                </div>
              </div>
            </div >
          ))}
        </div>
      )}
    </>
  );
};

export default DockReceipt;
